import css from 'styles/about.module.css'

export default function About() {
  return (
    <div className={`${css.container} pd mt`}>
      <div className={css.desc}>
        <h1 className={css.title}>
          <div>WELCOME TO THE</div>
          <div>MAUPS NFT</div>
        </h1>
        <p>
          MAUPS is a collection of 777 Pixel-like Apes NFTs—unique digital
          collectibles living on the Polygon blockchain. Each Maup is a unique
          programmatically generated piece of art, and some are rarer than
          others. Stored as ERC-721 tokens on the Polygon blockchain and hosted
          on IPFS. There are no bonding curves here. Buying Maups costs 62.0
          MATIC. There are no price tiers; One Maup costs the same for everyone.
          The direction of the Maups is up to the community. Let's build this
          together! <br />
          🐒 <i>#MAUPSGANG</i>
        </p>
      </div>
      <div className={css.images}>
        {Array.from({ length: 6 }, (_, i) => (
          <img
            className={css.image}
            width="100%"
            key={'maup' + i}
            src={require(`assets/maup${i}.png`)}
            alt={`ape showcase nr.${i}`}
          />
        ))}
      </div>
    </div>
  )
}
